var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GekkoButton',{attrs:{"text":_vm.$gettext('Upgrade'),"icon":"fa-solid fa-shopping-cart"},on:{"click":function($event){return _vm.changeBillingUrl()}}})}
var staticRenderFns = []

export { render, staticRenderFns }